import React from "react";
import "./about.css";
import AboutImg from "../../assets/about.jpg";
import Info from "./Info";

const About = () => {
  return (
    <section className="about section" id="about">
      <h2 className="section__title">Overview</h2>
      <span className="section__subtitle"></span>

      <div className="about__container container grid">
        {/* <img src={AboutImg} alt="" className="about__img" /> */}

        <div className="about__data">
          {/* <Info /> */}
          <p className="about__description">
          I currently work at{" "}
          <a
            href="https://www.thoughtly.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            Thoughtly
          </a>{" "}
          as Co-Founder, CTO, and Head of Product. Thoughtly is the AI voice agent platform built for revenue teams in high-consideration consumer industries like higher education, mortgage, insurance, and real estate. Companies in these industries receive thousands of inbound leads every month, far more than any human team can manage, and the winner is usually whoever reaches the lead first. Thoughtly's agents call new leads within seconds, qualify them, book meetings, and follow up across channels, including SMS, iMessage, WhatsApp, and email, until they connect, logging everything back to CRMs like Salesforce and HubSpot.
          </p>

          <p className="about__description">
          The platform is fully no-code and built for non-technical teams, and we pair it with a proven onboarding process. We have launched thousands of voice agents, conducted tens of millions of calls, and schedule over 100,000 appointments every month for publicly traded enterprises and SMBs. In September 2025, we raised a $5.5M seed round led by Armory Square Ventures, NVP, Afore, and Greycroft, bringing our total funding to $8.6M. At Thoughtly, I lead product and engineering, including product development, agentic AI, platform infrastructure, and ML ops.
          </p>

          <p className="about__description">
          Before Thoughtly, I was Co-Founder and CTO of Nudgem, a no-code, AI-powered, onsite experience builder that brands use to create custom storefronts that increase the lifetime value and conversion rates for their most valuable customers. I led the execution of product design and development. Nudgem was privately acquired in 2024. 
          </p>

          <p className="about__description">
          Prior to Nudgem, I was an engineering manager at Bluecore, a unicorn tech startup that uses ML to power marketing personalization. Over 800 of the largest retailers and brands used the campaign management tools we built to orchestrate sending billions of emails and SMS messages to their customers. 
          </p>

          <p className="about__description">
          Before that, I was a tech lead at IBM Watson. We built conversational AI and blockchain infrastructure to optimize the exchange of sensitive data for millions of patients in a HIPAA compliant way.
          </p>
        </div>
      </div> 
    </section>
  );
};

export default About;
